import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";
import type { BibleBookId } from "../../../lib/types/schema/bible/bibleManifestSchema";
import type { UseOpenApiInfiniteQueryOptions } from "../../../request/hooks/openApi/useOpenApiInfiniteQuery";

export const keyBibleSavesBase = ["bible", "saves"];

export const keyBibleSaves: BaseKeyFunction<
  UseOpenApiInfiniteQueryOptions<"/me/bible/saves">["params"]["query"]
> = (props = {}) => [
  ...keyBibleSavesBase,
  props?.type,
  props?.colors,
  props?.sort,
  props?.translation_ids,
  props?.per_page,
  props?.cursor,
];

export const keyBibleBookSaves: BaseKeyFunction<{
  translationId: number;
  bookId: BibleBookId;
}> = ({ translationId, bookId }) => [
  ...keyBibleSavesBase,
  translationId,
  bookId,
];
